import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function LeftPanel({
    items,
    onHoverItem,
}: {
    items: any[];
    onHoverItem: (item: any) => void;
}) {
    return (
        <div className="styles_LeftPanel__j42hT">
            <LeftItem
                key="all"
                href="/products"
                label="Tất cả sản phẩm"
                icon="https://api-v2.duoctamanh.com.vn/storage/655/all-product.svg" // Guessing a URL or using a placeholder
                iconActive="https://api-v2.duoctamanh.com.vn/storage/655/all-product.svg"
                onMouseEnter={() => onHoverItem(null)}
            />
            {items.map((item) => (
                <LeftItem
                    key={item.id}
                    href={`/products?category=${item.id}`}
                    label={item.name}
                    icon={item.avatar}
                    iconActive={item.avatar} // Assuming same icon for now or check if API provides one
                    hasSub={item.children && item.children.length > 0}
                    onMouseEnter={() => onHoverItem(item)}
                />
            ))}
        </div>
    );
}

/* ================= ITEM ================= */

function LeftItem({
    href,
    icon,
    iconActive,
    label,
    active,
    hasSub,
    badge,
    onMouseEnter,
}: {
    href: string;
    icon: string;
    iconActive?: string;
    label: string;
    active?: boolean;
    hasSub?: boolean;
    badge?: string;
    onMouseEnter?: () => void;
}) {
    const [hovered, setHovered] = useState(false);

    const currentIcon =
        (hovered || active) && iconActive ? iconActive : icon;

    return (
        <div 
            onMouseEnter={() => {
                setHovered(true);
                onMouseEnter?.();
            }}
            onMouseLeave={() => {
                setHovered(false);
            }}
        >
            <Link
                to={href}
                className={[
                    "styles_LeftPanelItem__l4X_d",
                    active && "styles_LeftPanelItemActive__VTo7C",
                    hasSub && "styles_LeftPanelItemWithSubItems__bXX8R",
                ]
                    .filter(Boolean)
                    .join(" ")}
            >
                <div className="styles_LeftPanelItemContent__iJGN4">
                    <div className="styles_LeftPanelIcon__r4TtA">
                        <span
                            style={{
                                boxSizing: "border-box",
                                display: "inline-block",
                                overflow: "hidden",
                                position: "relative",
                                maxWidth: "100%",
                            }}
                        >
                            {/* <span>
                                <img
                                    alt=""
                                    aria-hidden="true"
                                    src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%20width='24'%20height='24'/%3e"
                                />
                            </span> */}

                            <img
                                alt={label}
                                src={currentIcon}
                                decoding="async"
                                data-nimg="intrinsic"
                                style={{
                                    opacity: 1,
                                    transition: "opacity 0.2s ease-in-out",
                                    position: "absolute",
                                    inset: 0,
                                    margin: "auto",
                                    display: "block",
                                    width: 0,
                                    height: 0,
                                    minWidth: "100%",
                                    maxWidth: "100%",
                                    minHeight: "100%",
                                    maxHeight: "100%",
                                }}
                            />
                        </span>
                    </div>

                    <div className="styles_LeftPanelLabel__k8uR2">
                        <span>{label}</span>

                        {badge && (
                            <span className="styles_BadgeIcon__CBDxU inline-block">
                                <img alt="badge" src={badge} />
                            </span>
                        )}
                    </div>
                </div>
            </Link>
        </div>
    );
}
